module.exports = __webpack_public_path__ + "static/media/cookies.14e768b3.svg";